import ContentLayout from '@/layouts/ContentLayout';
import { FC } from 'react';
import NavLinkItem from '@/features/contentful/components/NavLinksWithContent/NavLinkItem';
import MainBodyToReact from '../MainBodyToReact';
import { applyPaddings } from '@/utils/applyPaddings';

export type TNavLink = {
    path: string;
    label: string;
    image: any;
};

interface NavLinksWithContentProps {
    title: string;
    subtitle: string;
    summary: any;
    navLinks: TNavLink[];
    paddingTop?: string;
    paddingBottom?: string;
}

const NavLinksWithContent: FC<NavLinksWithContentProps> = ({
    title,
    subtitle,
    summary,
    navLinks,
    paddingTop,
    paddingBottom,
}) => {
    return (
        <ContentLayout>
            <div
                className="tw-flex tw-flex-col lg:tw-flex-row"
                style={applyPaddings({ paddingTop, paddingBottom })}
            >
                <div className="tw-w-full  tw-px-[10px]">
                    <h4 className="tw-text-[14px] tw-uppercase tw-font-light tw-text-pink1 tw-font-gotham-medium tw-pb-[5px]">
                        {subtitle}
                    </h4>
                    <h3 className="tw-text-[#003865] tw-font-light tw-text-[26px] tw-font-gotham-bold tw-pb-[8px]">
                        {title}
                    </h3>
                    <div className="tw-text-menuText tw-text-[16px] tw-my-[26px] lg:tw-mb-0 tw-leading-6 tw-font-gotham-book tw-py-[10px]">
                        <MainBodyToReact body={summary} />
                    </div>
                </div>
                <div className="tw-w-full tw-px-[10px]">
                    <div
                        className="
                tw-grid
                tw-grid-cols-2
                md:tw-grid-cols-3
                lg:tw-grid-cols-2
                tw-gap-y-4
                tw-gap-4 "
                    >
                        {navLinks.map((item) => (
                            <NavLinkItem key={item.label} navLinkItem={item} />
                        ))}
                    </div>
                </div>
            </div>
        </ContentLayout>
    );
};

export default NavLinksWithContent;
